<ng-container *transloco="let t">
  <div class="row pb-48-36">
    <div class="col-12 col-xxl-6">
      <div>
        <div class="pb-20">
          <app-grid-item-title [title]="'My Clubs'" [isBlack]="true"/>
        </div>
        <div class="pb-20">
          <app-team-list-item>
            <ul class="team-info-list">
              <li>10000 Zagreb</li>
              <li>Hrvatska/Croatia</li>
              <li>{{ 'info@aksljeme.com' }}</li>
              <li>www.aksljeme.com</li>
            </ul>
          </app-team-list-item>
        </div>
        <div class="pb-20">
          <app-team-list-item>
            <ul class="team-info-list">
              <li>10000 Zagreb</li>
              <li>Hrvatska/Croatia</li>
              <li>{{ 'info@aksljeme.com' }}</li>
              <li>www.aksljeme.com</li>
            </ul>
          </app-team-list-item>
        </div>
        <div class="pt-20 d-flex justify-content-center">
          <app-rounded-button [label]="'Add club'" [btnClass]="'rounded-button--black-outline'"/>
        </div>
      </div>
    </div>
    <div class="col-12 col-xxl-6">
      <div>
        <div class="pb-20">
          <app-grid-item-title [title]="'My Teams'" [isBlack]="true"/>
        </div>
        <div class="pb-20">
          <app-team-list-item>
            <div class="fs-14">
              Lorem ipsum
            </div>
          </app-team-list-item>
        </div>
        <div class="pb-20">
          <app-team-list-item>
            <div class="fs-14">
              Lorem ipsum
            </div>
          </app-team-list-item>
        </div>
        <div class="pb-20">
          <app-team-list-item>
            <div class="fs-14">
              Lorem ipsum
            </div>
          </app-team-list-item>
        </div>
      </div>
    </div>
  </div>
</ng-container>
